export const getControllerFromUrl = (url: string) => {
  const matchResult = url.match(/^\/?(?<controller>\w+[_-]?\w+)\/(?<path>\w+)/)

  if (!matchResult?.groups || !matchResult.groups.controller || !matchResult.groups.path) {
    return ''
  }

  return matchResult.groups.controller
}
